
import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Modal from 'components/Modal';

import {
  Question,
  Title,
  Answer,
  PhotoGrid,
  Photo,
  BigPicture,
} from './styles';


const MapTaskQuestions = ({ questions }) => (
  <ul>
    {questions.map(question => (
      <Question key={question.id}>
        <Title>{question.service_field_name}</Title>
        <Answer>{question.service_field_option_name || question.value}</Answer>
      </Question>
    ))}
  </ul>
);

const DetailModal = ({
  detailModalIsOpen, setDetailModalIsOpen, taskDetail,
}) => {
  const [fieldsData, setFieldsData] = useState([]);
  const [openedPicture, setOpenedPicture] = useState(false);
  const [openedPictureModalIsOpen, setOpenedPictureModalIsOpen] = useState(false);

  const getFields = () => {
    let fields = [];
    if (taskDetail && taskDetail.fields) {
      taskDetail.fields.forEach((field) => {
        const alreadyInQuestions = fields.find(actualField => actualField.service_field_id === field.service_field_id);
        if (alreadyInQuestions) {
          fields = fields.filter(actualField => actualField.service_field_id !== field.service_field_id);
          const parsedField = {
            ...field,
            service_field_option_name: `${alreadyInQuestions.service_field_option_name}; ${field.service_field_option_name}`,
          };
          fields.push(parsedField);
        } else {
          fields.push(field);
        }
      });
    }
    return fields;
  };

  const firstTaskQuestions = [{
    id: -2,
    service_field_name: 'SERVIÇO PEDIDO EM:',
    service_field_option_name: moment(taskDetail.created).format('DD/MM/YYYY'),
  }, {
    id: -1,
    service_field_name: 'ENDEREÇO:',
    service_field_option_name: taskDetail.address,
  }];

  if (taskDetail.period_text) {
    firstTaskQuestions.push({
      id: -3,
      service_field_name: 'MELHOR HORÁRIO:',
      service_field_option_name: taskDetail.period_text,
    });
  }

  if (taskDetail.specific_date) {
    firstTaskQuestions.push({
      id: -4,
      service_field_name: 'QUANDO:',
      service_field_option_name: moment(taskDetail.specific_date).format('DD/MM/YYYY'),
    });
  } else if (taskDetail.time_text) {
    firstTaskQuestions.push({
      id: -5,
      service_field_name: 'QUANDO:',
      service_field_option_name: taskDetail.time_text,
    });
  }

  useEffect(() => {
    setFieldsData([...firstTaskQuestions, ...getFields()]);
  }, [taskDetail, fieldsData.length]);

  return (
    <Modal
      isOpen={detailModalIsOpen}
      toggle={() => setDetailModalIsOpen(!detailModalIsOpen)}
      title="DETALHES DO PEDIDO"
    >
      {fieldsData && fieldsData.length > 0 && (
        <Fragment>
          <MapTaskQuestions questions={fieldsData} />

          {taskDetail.photos && taskDetail.photos.length > 0 && (
            <Fragment>
              <Title>Fotos anexadas:</Title>
              <PhotoGrid>
                {taskDetail.photos.map(photo => (
                  <Photo
                    key={photo.id}
                    src={photo.url}
                    onClick={() => {
                      setOpenedPictureModalIsOpen(true);
                      setOpenedPicture(photo);
                    }} 
                  />
                ))}
              </PhotoGrid>
            </Fragment>
          )}

          <Modal
            isOpen={openedPictureModalIsOpen}
            toggle={() => {
              setOpenedPictureModalIsOpen(false);
              setOpenedPicture({});
            }}
            title={openedPicture.description ? openedPicture.description : 'FOTOS ANEXADAS'}
            width="800px"
          >
            <BigPicture>
              <img src={openedPicture.url} alt="big service image" />
            </BigPicture>
          </Modal>

        </Fragment>
      )}

    </Modal>
  );
};

const mapStateToProps = state => ({
  taskDetail: state.task.taskDetail,
});

export default connect(
  mapStateToProps,
)(DetailModal);
